export default __webpack_public_path__ + "static/media/dark_mode_black_24dp.fdb51e7c.svg";